export default {
    idUser(state) { return Object.keys(state.data).length ? state.data.id : null; },
    getUserFullName(state) {
        if (state.data.first_name && state.data.last_name) {
            return `${state.data.first_name} ${state.data.last_name}`;
        } else if (state.data.first_name && !state.data.last_name) {
            return state.data.first_name;
        } else if (!state.data.first_name && state.data.last_name) {
            return `Sr(a). ${state.data.last_name}`;
        } else {
            return 'Sem nome';
        }
    },
}
